import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress, TableCell, TableRow } from "@mui/material";

/** Full-width centered loading spinner row (colSpan from caller). */
export function CarrierTabLoadingRow({ colSpan }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
          }}
        >
          <CircularProgress />
        </Box>
      </TableCell>
    </TableRow>
  );
}

CarrierTabLoadingRow.propTypes = {
  colSpan: PropTypes.number.isRequired,
};

/** Empty-state single row */
export function CarrierTabEmptyRow({ colSpan, message }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        {message}
      </TableCell>
    </TableRow>
  );
}

CarrierTabEmptyRow.propTypes = {
  colSpan: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
};
